const map = {
	"./1": 58553,
	"./1.json": 58553,
	"./background0.webp": 2145,
	"./background1.webp": 32390,
	"./background2.webp": 74727,
	"./background3.webp": 76900,
	"./background4.webp": 76629,
	"./background5.webp": 25450,
	"./background6.webp": 61515,
	"./informe2025-music.mp3": 27852,
	"./little-girl.gif": 14545,
	"./mobile/part0.webp": 20185,
	"./mobile/part1.webp": 9150,
	"./mobile/part2.webp": 18751,
	"./mobile/part3.webp": 40508,
	"./mobile/part4.webp": 92877
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59509;